import React from 'react'
import MLCalendar from '../MLCalendar'
import Footer from '../Footer'

function Calendar() {
  return (
    <>
      <MLCalendar/>
      <Footer/>
    </>
  )
}

export default Calendar
